export default {
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40 // also NUM_SOUTH
};


//////////////////
// WEBPACK FOOTER
// ../~/rc-tabs/es/KeyCode.js
// module id = 2716
// module chunks = 1